import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";
import type { ConversationCreditReason } from "@sage-mcp/shared";

// Why a superuser waived a conversation's cost. Descriptors rather than <Trans>
// so the same list drives the credit dialog's picker, the badge on the
// conversation detail and the justification table on the customer page.
//
// Modelled on feedback-labels.ts. Adding a code here is only one of three edits —
// see the header of packages/shared/src/conversation-credits.ts.
export const CREDIT_REASON_LABELS: Record<ConversationCreditReason, MessageDescriptor> = {
  product_bug: msg`Product bug`,
  wrong_answer: msg`Wrong answer`,
  tool_error: msg`Technical or tool error`,
  support_investigation: msg`Support investigation`,
  internal_testing: msg`Internal testing`,
  demo: msg`Demo`,
  sales_gesture: msg`Commercial gesture`,
  duplicate_turn: msg`Duplicate turn`,
  other: msg`Other`,
};
